import { Box, Typography } from '@mui/material';
import {
    ResponsiveContainer, LineChart, Line,
    CartesianGrid, XAxis, YAxis, Tooltip, Legend
} from 'recharts';

const RequestsChart = ({
    data,
    showTotalRequests,
    showUniqueUsers,
    mode
}) => {
    return (
        <Box sx={{ height: 'calc(100vh - 135px)', width: '100%', p: 2 }}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" />

                    {/* <YAxis /> */}
                    <YAxis
                        width={70}
                        tick={({ x, y, payload }) => {
                            return (
                                <g transform={`translate(${x + 10}, ${y})`}>
                                    <text x={-12} y={0} dy={4} textAnchor="start" fontSize={15} fill="#333" direction="rtl">
                                        {payload.value.toLocaleString()}
                                    </text>
                                </g>
                            );
                        }}
                    />

                    <Tooltip />
                    <Legend />

                    {showTotalRequests && (
                        <Line
                            type="monotone"
                            dataKey="totalRequests"
                            name="כמות קריאות"
                            stroke="#8884d8"
                            strokeWidth={4}
                            dot={{ r: 5 }}
                            activeDot={{ r: 7 }}
                        />
                    )}

                    {mode === 'all' && showUniqueUsers && (
                        <Line
                            type="monotone"
                            dataKey="uniqueUsers"
                            name="משתמשים שונים"
                            stroke="#82ca9d"
                            strokeWidth={4}
                            dot={{ r: 5 }}
                            activeDot={{ r: 7 }}
                        />
                    )}
                </LineChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default RequestsChart;
